var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fading","appear":""}},[(_vm.isShown)?_c('div',{staticClass:"popup position_base fixed parent h-centered borderBox",attrs:{"role":"presentation"}},[_c('section',{class:( _obj = {
        'litter relative background-color_white shadow_spread': true,
        litter_normal: !_vm.smallLitter,
        litter_small: _vm.smallLitter,
        litter_fitContent: _vm.isLitterFitContent
      }, _obj[_vm.className] = _vm.className, _obj[("litter_" + _vm.modifier)] = _vm.modifier, _obj )},[_vm._t("default"),_vm._v(" "),_c('base-button',{attrs:{"action":_vm.onCloseModal,"class-name":_vm.closeButtonClasses + " relative","unstyled":""}},[_c('icon-close')],1)],2)]):_vm._e()])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f04ee2dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalContainer.vue
// module id = null
// module chunks = 